<template>
  <RevModal
    :name="MODAL_NAMES.VERIFIED_REFURBISHED"
    :title="i18n(translations.title)"
    variant="panel"
  >
    <template #body>
      <RevIllustration
        alt=""
        class="mb-24 w-full"
        :height="180"
        src="/img/product/verified-refurbished/illustration.png"
        :width="327"
      />
      <ContentRow
        :labels="[i18n(translations.item1text)]"
        :title="i18n(translations.item1title)"
      >
        <IconTools aria-hidden />
      </ContentRow>
      <ContentRow
        :labels="[i18n(translations.item2text)]"
        :title="i18n(translations.item2title)"
      >
        <IconCheckInCircle aria-hidden />
      </ContentRow>
      <ContentRow
        :labels="[i18n(translations.item3text)]"
        :title="i18n(translations.item3title)"
      >
        <IconRefund aria-hidden />
      </ContentRow>
      <div class="mt-24 text-center">
        <RevLink :to="link">
          {{ i18n(translations.readMore) }}
        </RevLink>
      </div>
      <WarrantyExclusion />
    </template>
  </RevModal>
</template>

<script lang="ts" setup>
import { useRouteLocationWithLocale } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { RevModal } from '@ds/components/Modal'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconRefund } from '@ds/icons/IconRefund'
import { IconTools } from '@ds/icons/IconTools'

import { CMS } from '~/scopes/cms/routes-names'
import { MODAL_NAMES } from '~/scopes/product/constants'

import ContentRow from '../../../ContentRow/ContentRow.vue'
import WarrantyExclusion from '../../../WarrantyExclusion/WarrantyExclusion.vue'

import translations from './VerifiedRefurbishedModal.translations'

const i18n = useI18n()
const resolveLocalizedRoute = useRouteLocationWithLocale()

const link = resolveLocalizedRoute({
  name: CMS.ARTICLE,
  params: {
    pageName: 'impact-of-refurbished-on-environment',
    category: 'news',
  },
})
</script>
